module.exports = __webpack_public_path__ + "static/img/bg_business.b2178f4e.png";